import React, { useEffect, useState } from 'react';
import validator from 'validator';
import { postNewsLetter } from "../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../utils";
import { IoClose, IoMail, IoRocket, } from 'react-icons/io5';

function NewsletterPopup() {
    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    let errorsObj = { email: '' };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowModal(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => setShowModal(false);

    const onSubmitNewsLatter = (e) => {
        e.preventDefault();
        let errorObj = { ...errorsObj };
        let error = false;
        if (!email) {
            errorObj.email = 'Please Enter Email';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter valid email';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setIsDisabled(true);

        // Close modal immediately when button is clicked
        setShowModal(false);

        let obj = {
            email: email
        };

        postNewsLetter(obj)
            .then(response => {
                setIsDisabled(false);
                setIsSuccess(true);
                toast.success(response.data.message);
                // Reset form state
                setEmail('');
                setErrors(errorsObj);
            })
            .catch(err => {
                setIsDisabled(false);
                toast.error(Utils.getErrorMessage(err));
                // Don't reopen modal on error, just show toast
            });
    };

    if (!showModal) return null;

    return (
        <div className="newsletter-overlay">
            <div className="newsletter-modal">
                {/* Decorative Elements */}
                <div className="decorative-circle-1"></div>
                <div className="decorative-circle-2"></div>

                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="close-button"
                >
                    <IoClose />
                </button>

                {/* Content */}
                <div className="modal-content">

                    <>
                        {/* Header */}
                        <div className="header-section mb-0">
                            <div className="header-icon">
                                <IoMail size={40} color="white" />
                            </div>
                            <h2 className="header-title">
                                Subscribe to Our Newsletter
                            </h2>
                            {/* <p className="header-description">
                                Get exclusive updates, tips, and special offers delivered straight to your inbox
                            </p> */}
                        </div>

                        {/* Benefits */}
                        <div className="benefits-container">
                            {/* <div className="benefit-item">
                                    <IoGift size={16} color="white" />
                                    <span className="benefit-text">Exclusive Offers</span>
                                </div> */}
                            {/* <div className="benefit-item">
                                <IoRocket size={16} color="white" />
                                <span className="benefit-text">Latest Updates</span>
                            </div> */}
                        </div>

                        {/* Form */}
                        <form onSubmit={onSubmitNewsLatter}>
                            <div className="form-container">
                                <div className="input-wrapper">
                                    <input
                                        type="email"
                                        className={`email-input ${errors.email ? 'error' : ''}`}
                                        placeholder="Enter your email address"
                                        value={email}
                                        disabled={isDisabled}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                {errors.email && (
                                    <div className="error-message">
                                        {errors.email}
                                    </div>
                                )}
                            </div>

                            <button
                                type="submit"
                                disabled={isDisabled}
                                className="subscribe-button"
                            >
                                {isDisabled ? (
                                    <span className="button-content">
                                        <div className="loading-spinner"></div>
                                        Subscribing...
                                    </span>
                                ) : (
                                    'Subscribe Now'
                                )}
                            </button>
                        </form>

                        {/* Footer Text */}
                        {/* <p className="footer-text">
                            🔒 We respect your privacy. Unsubscribe at any time.
                        </p> */}
                    </>

                </div>
            </div>
        </div>
    );
}

export default NewsletterPopup;
